module.exports = __webpack_public_path__ + "img/augsburg_cover.50912342.jpg";